export const ArrowLeftIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 24"
      width="1em"
      height="1em"
      fill="currentColor"
      {...props}
    >
      <path d="M11.5001 21.9999C11.235 21.9997 10.9808 21.8942 10.7935 21.7066L1.79346 12.7066L1.74346 12.6666C1.61029 12.5162 1.5255 12.3292 1.50013 12.1299C1.49345 12.0634 1.49345 11.9964 1.50013 11.9299C1.51447 11.6907 1.61654 11.4652 1.7868 11.2966L10.7868 2.2966C10.9743 2.10934 11.2285 2.00415 11.4935 2.00415C11.7585 2.00415 12.0126 2.10934 12.2001 2.2966C12.3874 2.4841 12.4926 2.73827 12.4926 3.00327C12.4926 3.26827 12.3874 3.52244 12.2001 3.70994L4.91346 10.9999H22.5001C22.7653 10.9999 23.0197 11.1053 23.2072 11.2928C23.3948 11.4804 23.5001 11.7347 23.5001 11.9999C23.5001 12.2652 23.3948 12.5195 23.2072 12.707C23.0197 12.8946 22.7653 12.9999 22.5001 12.9999H4.91346L12.2068 20.2933C12.3941 20.4808 12.4993 20.7349 12.4993 20.9999C12.4993 21.2649 12.3941 21.5191 12.2068 21.7066C12.0194 21.8942 11.7653 21.9997 11.5001 21.9999Z" />
    </svg>
  );
};
